import React from 'react';
import { ChevronDown } from 'lucide-react';

// Hero background image
const HERO_IMAGE = 'https://customer-assets-wrfwihn1.emergentagent.net/job_b7ed69af-0027-40f7-b482-63ed3c17f383/artifacts/684vzkny_IMG_4729.webp';

export const HeroSection = ({ onExplore, onScrollDown }) => {
  return (
    <section className="hero-section" style={{ marginTop: 0 }}>
      <div className="hero-background">
        <img 
          src={HERO_IMAGE}
          alt="Elina K. Photography"
        />
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content" style={{ 
        position: 'absolute', 
        bottom: '15%', 
        left: '50%', 
        transform: 'translateX(-50%)',
        textAlign: 'center'
      }}>
        <h1 className="fade-in-up" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '0.75rem',
          fontWeight: 400,
          color: 'white',
          letterSpacing: '0.2em',
          textTransform: 'uppercase'
        }}>
          Family Photographer in Dubai
        </h1>
        <button 
          onClick={onExplore}
          className="hero-cta fade-in-up stagger-2"
          style={{ marginTop: '2rem' }}
        >
          View Portfolio
        </button>
      </div>
      <div className="absolute bottom-4 left-0 right-0 z-10 flex justify-center pointer-events-none">
        <button
          type="button"
          className="animate-bounce cursor-pointer pointer-events-auto"
          onClick={onScrollDown}
          aria-label="Scroll down"
          data-testid="hero-scroll-down"
        >
          <ChevronDown className="w-8 h-8 text-white/60" />
        </button>
      </div>
    </section>
  );
};
